import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Lightbox } from 'ngx-lightbox';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProjectHelper from 'src/app/helpers/project-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import Asset from 'src/app/model/asset';
import Company from 'src/app/model/company/company';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import IPBoardPart from 'src/app/model/product/ip-board/ip-board-part';
import Product from 'src/app/model/product/product';
import Address from 'src/app/model/project/address';
import { BaseProject } from 'src/app/model/project/base-project';
import { Project } from 'src/app/model/project/project';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { ClientIPBoardAndPlacementHelper } from 'src/app/shared/project-components/client-project-form/base-project/client-ip-board-form/helper/client-ip-board-and-placement-helper';
import { FileHelper } from '../../../../../helpers/file-helper';

@Component({
  selector: 'project-detail-card',
  templateUrl: './detail-card.component.html',
  styleUrls: ['./detail-card.component.scss'],
})
export class DetailCardComponent implements OnInit, OnChanges {
  @Input()
  cardType:
    | 'configuration'
    | 'design'
    | 'placement'
    | 'facturation'
    | 'execution';

  @Input()
  projectPlacement?: ProjectPlacement;

  @Input()
  products: Product[] = [];

  @Input()
  firstProduct?: Product;

  @Input()
  assets: Asset[] = [];

  @Input()
  ipBoardExamples: Asset[] = [];

  @Input()
  project?: Project;

  @Input()
  baseProject?: BaseProject;

  @Input()
  company?: Company;

  @Input()
  alternativeTitle?: string;

  @Input()
  outerTitle: boolean = false;

  @Input()
  client: boolean = false;

  @Input()
  installerView: boolean = false;

  @Input()
  fromOldSystem: boolean = false;

  @Input()
  componentsExecuted: boolean | null = null;

  @Output()
  addressChanged = new EventEmitter<Address>();

  title: string = '';
  placementTypePreviewUrl: string;

  pdfList: Asset[];
  isImage = FileHelper.isImage;
  constructor(private _lightbox: Lightbox) {}

  ngOnInit() {
    if (!StringHelper.isEmpty(this.alternativeTitle)) {
      this.title = this.alternativeTitle;
      return;
    }
    if (this.cardType === 'configuration') {
      this.title = 'Configuratie';
      if (this.firstProduct != null) {
        this.calculatePlacementTypePreviewUrl();
      }
    } else if (this.cardType === 'design') {
      this.title = 'Ontwerp';
    } else if (this.cardType === 'placement') {
      this.title = 'Plaatsing';
    } else if (this.cardType === 'facturation') {
      this.title = 'Facturatie';
    } else if (this.cardType === 'execution') {
      this.title =
        this.baseProject == null ||
        !ProjectHelper.EXECUTED_FOR_CLIENT_STATUSES.includes(
          this.baseProject.status
        )
          ? 'Uitvoering'
          : 'Uitgevoerd';
    }

    this.processAssets();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['firstProduct'] && this.cardType === 'configuration') {
      this.calculatePlacementTypePreviewUrl();
    }
    if (
      (changes['assets'] && !changes['assets'].isFirstChange()) ||
      (changes['ipBoardExamples'] &&
        !changes['ipBoardExamples'].isFirstChange())
    ) {
      this.processAssets();
    }
  }

  private processAssets(): void {
    if (
      !CollectionHelper.isPopulated(this.assets) &&
      !CollectionHelper.isPopulated(this.ipBoardExamples)
    ) {
      this.pdfList = null;
    } else {
      const pdfList: Asset[] = [];

      if (CollectionHelper.isPopulated(this.assets)) {
        this.assets.forEach((a) => {
          if (FileHelper.isPdf(a)) {
            pdfList.push(a);
          }
        });
      }
      if (CollectionHelper.isPopulated(this.ipBoardExamples)) {
        pdfList.push(
          ...this.ipBoardExamples.filter((a) => FileHelper.isPdf(a))
        );
      }

      this.pdfList = pdfList;
    }
  }

  private calculatePlacementTypePreviewUrl(): void {
    if (
      this.firstProduct == null ||
      (this.firstProduct as IPBoard).boardPart == null
    ) {
      this.placementTypePreviewUrl = null;
      return;
    }

    const boardPart = (this.firstProduct as IPBoard).boardPart;
    const isAdhesiveBoard =
      ClientIPBoardAndPlacementHelper.isAdhesiveBoard(boardPart);

    const mockBoardPart = new IPBoardPart();
    mockBoardPart.boardType = (
      this.firstProduct as IPBoard
    ).boardPart.boardType;
    mockBoardPart.placementType = (
      this.firstProduct as IPBoard
    ).boardPart.placementType;

    const selectedPlacementOption = isAdhesiveBoard
      ? ClientIPBoardAndPlacementHelper.getInitialSelectedAdhesiveBoardPlacementOption(
          mockBoardPart
        )
      : ClientIPBoardAndPlacementHelper.getInitialSelectedIPBoardPlacementOption(
          mockBoardPart
        );

    this.placementTypePreviewUrl =
      selectedPlacementOption == null
        ? null
        : selectedPlacementOption.previewUrl;
  }

  openLightbox(assets: Asset[], index = 0): void {
    let albums = [];
    const imageAssets = assets.filter((a) => FileHelper.isImage(a));
    for (let asset of imageAssets) {
      if (asset != null) {
        const src = 'api/assets/' + asset.uuid;
        const caption = asset.name;
        const thumb = 'api/assets/' + asset.uuid;
        const album = {
          src: src,
          caption: caption,
          thumb: thumb,
        };
        albums.push(album);
      }
    }
    this._lightbox.open(albums, index);
  }
}
